import dayjs from "dayjs";

import { Option } from "@/@types/generics/Option";
import { Department } from "@/@types/sintegrada/Department";
import { defaultGender } from "@/components/GenderSelect";
import { HospitalWard } from "@/@types/sintegrada/HospitalWard";
import { defaultRiskClassification } from "@/components/sintegrada/Selects/RiskClassificationSelect";

const startDate = dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm");
const endDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

export const occupationFilterInitialValues = {
	startDate,
	endDate,
	department: {} as Option<Department>,
	hospitalWards: [] as Option<HospitalWard>[],
	gender: defaultGender,
	minAge: "",
	maxAge: "",
	riskClassification: defaultRiskClassification,
	individual: false,
};

export type TypeofOccupationFilterInitialValues = typeof occupationFilterInitialValues;
